// Poorly named Quiz slice.  There is no real concept of "Quiz", however
// we don't currently have a container for a set of modules, so will use this for now.
// In the future, when we resolve that tech debt and have a name for a group of modules
// that can be assigned to a user, this will need to be renamed.

import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { Attempt } from '../../models/global.types'

export interface QuizState {
  currentAttempt: Attempt | null
}

export const quizInitialState: QuizState = {
  currentAttempt: null
}

export const quizSlice = createSlice({
  name: 'quiz',
  initialState: quizInitialState,
  reducers: {
    setCurrentAttempt: (state, action: PayloadAction<Attempt>) => {
      state.currentAttempt = action.payload
    }
  }
})

export const {
  setCurrentAttempt
} = quizSlice.actions

export default quizSlice.reducer
